<template>
    <v-container fluid @keydown.enter.prevent="pesquisar">
        <v-responsive>
     <v-row>
        <v-col>
            <div class="title-container">
              <h1 class="h1">Intercorrência</h1>
          </div>
        </v-col>
    </v-row>
      <p></p>
        <v-card-title>
            <v-row class="mt-2" >
                <v-col >
                    <v-data-table :loading="loadingIntercorrencia"  :items="intercorrencia"   :search="search"  :headers="headers"  
                    :single-expand="singleExpand" :expanded.sync="expanded" show-expand  fixed-header  :items-per-page="-1">

                        <!-- <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="py-4 grey lighten-2  text-start"> 
                            <AcionamentoExpand :item="item" />
                            </td>
                        </template> -->
                        <!-- Campo de pesquisa  -->
                        <template v-slot:top>
                            <v-row>
                               <v-col >
                                    <v-text-field v-model="dataInicial" label="Data Inicial" dense outlined type="date" clearable />
                                </v-col>
                                <v-col >
                                    <v-text-field v-model="dataFinal" label="Data Fim" dense outlined type="date" clearable />
                                </v-col>
                                <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp">
                                    <v-select v-model="filtroEquipeRemocao" hide-details label="Registrado Por?" :items="statusOptions" item-text="label" item-value="value" dense outlined  clearable />
                                </v-col>
                                <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">
                                    <v-select v-model="filtroIntercorrencia" hide-details label="Intercorrência ou Ocorrência" :items="status" item-text="label" item-value="value" dense outlined  clearable />
                                </v-col>
                               <v-col >
                                    <v-autocomplete :loading="isLoadingPaciente" v-model="filtroPaciente"  label="Paciente" :items="paciente" item-text="nome" item-value="id" dense outlined  clearable />
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="2" v-if="$vuetify.breakpoint.lgAndUp">
                                    <v-text-field label="Pesquisar" dense  outlined v-model="search" class="mx-0" append-icon="mdi-magnify" clearable/>
                                </v-col>
                                <v-col  class="text-right">
                                    <v-btn color="gree" class="ma-1" small @click="atualizar"> <v-icon left>mdi-reload </v-icon> Atualizar</v-btn>
                                    <v-btn class="ma-1" small @click="collapseAll"> Recolher Linhas </v-btn>
                                    <v-btn color="success" class="ma-1" small @click="validateAndSearch">Pesquisar</v-btn>
                                    <v-btn color="error" class="ma-1" small @click="dialog.create = true"> <div class="d-flex flex-column compact-btn-text">  <span>Nova</span> <span>Intercorrência</span> </div> </v-btn>
                                  
                                </v-col>
                            </v-row>
                        <v-expansion-panels v-if="$vuetify.breakpoint.lgAndUp">
                            <v-expansion-panel>
                            <v-expansion-panel-header>
                                <v-row class="align-center">
                                <v-spacer></v-spacer>
                                <v-col cols="auto">
                                    <h3 class="blod_color">Resumo...</h3>
                                </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row dense>
                                    <h3 class="blod_color mb-5" style="text-align: center; width: 90%; font-size:small;">DADOS RESUMIDOS</h3>
                                    </v-row>

                                    <v-row dense>
                                    <!-- Totais gerais -->
                                    <v-col cols="3" style="font-size:small;">
                                        <v-div>
                                        <div><span class="blod_color">Qtd. Aciona. Geral:</span> {{ quantidadeAcionamentos }}</div>
                                        <div><span class="red_color">Qtd. Aciona. Intercorrência:</span> {{ quantidadeIntercorrencia}}</div>
                                        <div><span class="orange_color">Qtd. Aciona. Ocorrência:</span> {{ quantidadeOcorrencia }}</div>
                                        <div><span class="red_color">Qtd. Aciona. Platonista:</span> {{ quantidadeAcionamentosRemocao }}</div>
                                        <div><span class="red_color">Qtd. Aciona. Assistencial:</span> {{ quantidadeAcionamentosAssistencia }}</div>
                                        <div><span class="blod_color">Qtd. Hospitalização:</span> {{ quantidadeHospitalizacao }}</div>
                                        <div><span class="blod_color">Qtd. Resolução em Domicílio:</span> {{ quantidadeNaoHospitalizacao }}</div>
                                        </v-div>
                    
                                       
                                    </v-col>

                                    <!-- Por Paciente -->
                                    <v-col cols="3" style="font-size:small;">
                                        <div>
                                        <span class="blod_color">Acionamentos por Paciente:</span>
                                        <ul style="list-style-type: none; padding-left: 0; color: #000;">
                                            <li v-for="(quantidade, nome) in quantidadeAcionamentosPorPaciente" :key="nome">
                                            {{ nome }}: {{ quantidade }}
                                            </li>
                                        </ul>
                                        </div>
                                    </v-col>

                                    <!-- Por Tipo -->
                                    <v-col cols="2" style="font-size:small;">
                                        <div>
                                            <span class="red_color">Acionamentos por Tipo:</span>
                                            <ul style="list-style-type: none; padding-left: 0; color: #000;">
                                            <li v-for="(quantidade, causa) in tipoFiltradas" :key="causa">
                                                {{ causa }}: {{ quantidade }}
                                            </li>
                                            </ul>
                                        </div>
                                    </v-col>

                                    <!-- Por Causa -->
                                    <v-col cols="2" style="font-size:small;">
                                    <div>
                                        <span class="red_color">Acionamentos por Causa:</span>
                                        <ul style="list-style-type: none; padding-left: 0; color: #000;">
                                        <li v-for="(quantidade, causa) in causasFiltradas" :key="causa">
                                            {{ causa }}: {{ quantidade }}
                                        </li>
                                        </ul>
                                    </div>
                                    </v-col>


                                    <!-- Por Procedimento -->
                                    <v-col cols="2" style="font-size:small;">
                                        <div>
                                        <span class="orange_color">Acionamentos por Procedimento:</span>
                                        <ul style="list-style-type: none; padding-left: 0; color: #000;">
                                            <li v-for="(quantidade, causa) in quantidadeAcionamentosPorTipoProcedimento" :key="causa">
                                            {{ causa }}: {{ quantidade }}
                                            </li>
                                        </ul>
                                        </div>
                                    </v-col>
                                    
                                </v-row>

                            </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>


                        </template>
                        <!-- Customizando a exibição do campo competência -->
                        <template v-slot:[`item.colaborador`]="{ item }">
                            {{ item.colaborador.apelido }} - {{item.colaborador.especialidade.nome}}
                        </template>
                        <template v-slot:[`item.remocao`]="{ item }">
                            {{ item.equipe_remocao ? 'Plantonista': 'Assistencial'}}
                        </template>
                        <template v-slot:[`item.intercorrencia`]="{ item }">
                            {{ item.intercorrencia ? 'Intercorrência': 'Ocorrência'}}
                        </template>
                        <template v-slot:[`item.reinternacao`]="{ item }">
                            {{ item.reinternacao ? 'Sim': 'Não'}}
                        </template>
                        <template v-slot:[`item.data`]="{ item }">
                            {{ item.data | formatDatabr }} - {{ UtilsFunc.formatHora(item.hora) }}
                        </template>
                        <template v-slot:[`item.hora`]="{ item }">
                            {{ UtilsFunc.formatHora(item.hora) }}
                        </template>
                         <template v-slot:[`item.edit`]="{ item }">
                            <v-btn icon @click="onSelectIntercorrencia(item, 'update')">
                                <v-icon color="green">mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                       
                        <template v-slot:[`item.ativo`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="green" v-if="item.ativo === true">mdi-check-circle-outline</v-icon>
                            <v-icon v-bind="attrs" v-on="on" color="red" v-else-if="item.ativo === false">mdi-close-circle-outline</v-icon>
                            </template>
                            <span>{{ item.ativo === true ? 'Ativo' : 'Inativo' }}</span>
                        </v-tooltip>
                        </template>

                    </v-data-table>
                    <!-- Novo Intercorrência -->
                    <v-dialog
                        v-if="dialog.create"
                        v-model="dialog.create"
                        max-width="90%"
                    >
                        <v-card>
                        <v-card-title class="blod_color">
                            Nova Intercorrência:
                            <v-spacer />
                            <!-- Botão e ícone de fechar a tela -->
                            <v-btn icon @click="closeDialog">
                            <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <!-- Abre a página de solicitação de novo medicamento -->
                        <v-card-text>
                            <!-- <NovaIntercorrencia   :onSubmit="save"  @close="dialog.create = false" /> -->
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                    <!-- Editar -->
                    <v-dialog
                        v-if="dialog.update"
                        v-model="dialog.update"
                        max-width="90%"
                    >
                        <v-card>
                        <v-card-title class="blod_color">
                            Editar Intercorrência ID: {{selectedIntercorrencia.id}} - Paciente: {{selectedIntercorrencia.paciente.nome}}
                            <v-spacer />
                            <!-- Botão e ícone de fechar a tela -->
                            <v-btn icon @click="closeDialog">
                            <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-title>
                        <!-- Abre a página de solicitação de novo medicamento -->
                        <v-card-text>
                            <EditarAnaliseFarmaceutica :analiseFarmaceutica="selectedIntercorrencia"  :onSubmit="edit"  @close="dialog.update = false" />
                        </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-card-title>
        </v-responsive>
    </v-container>
</template>
<script>
import api from '../../../http';
import '../../../assets/css/styles.css';
import UtilsFunc from '../../../service/utilsFunc';
// import NovaIntercorrencia from './NovaIntercorrencia.vue';
// import AcionamentoExpand from './AcionamentoExpand.vue';
// import NovaOcorrencia from './NovaOcorrencia.vue';


export default {
  name:"Intercorrencia",
    data() {
        const hoje = new Date();
        const dataFinal = hoje.toISOString().split('T')[0];
        const primeiroDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        const dataInicial = primeiroDiaMesAnterior.toISOString().split('T')[0];
        return {
            dataInicial,
            dataFinal,
        UtilsFunc, // <-- isso aqui é importante
        ...UtilsFunc.withCRUDUtils({
                loadingIntercorrencia: false,
                isLoadingPaciente: false,
                intercorrencia: [],
                selectedIntercorrencia: null, 
                // headers: [
                //     { text: "ID", sortable: true,value: "id",  },
                //     { text: "ID - Paciente", sortable: true,  width: 250,  value: "paciente.nome" },
                //     { text: "Tipo", sortable: true, value: "intercorrencia" },
                //     { text: "Procedimento", sortable: true,  width: 210, value: "tipo_ocorrencia.nome" },
                //     { text: "Tipo", sortable: true,  width: 120, value: "tipo.nome" },
                //     { text: "Quem Acionou", sortable: true,  value: "quem_acionou" },
                //     { text: "Registrado Por? ", sortable: true, align: "center", value: "remocao" },
                //     { text: "Quem Registrou", sortable: true, value: "colaborador" },
                //     { text: "Causa", sortable: true,  value: "causa.nome" },
                //     { text: "Data", sortable: true, value: "data" },
                //     { text: "Hora", sortable: true, value: "hora" },
                //     { text: "Hospitalização", sortable: true,  value: "reinternacao" },
                // ],
                dialog: {
                    create: false,
                    create2: false,
                },
                singleExpand: false,
                expanded: [],
                filtroEquipeRemocao: null,
                filtroIntercorrencia: null,
                paciente: [],
                filtroPaciente: null,
                statusOptions: [
                    { label: "Plantonista", value: true },
                    { label: "Assistencial", value: false }
                ],
                status: [
                    { label: "Intercorrência", value: true },
                    { label: "Ocorrência", value: false }
                ],
            })
        }
    },
    components: {
        // NovaIntercorrencia,
        // AcionamentoExpand,
        // NovaOcorrencia,
    },
    methods: {
        async getIntercorrencia() {
        this.loadingIntercorrencia = true;
        try {
            let params = {};

            if (this.dataInicial) params.data_inicio = this.dataInicial;
            if (this.dataFinal) params.data_fim = this.dataFinal;
            if (this.filtroPaciente !== null) {
                    params.paciente = this.filtroPaciente;
                }

            const response = await api.get("/remocao/intercorrencia/", { params });

            this.intercorrencia = response.data;
            console.log(this.intercorrencia)
        } catch (error) {
            this.$toast.error(`Desculpe! Aconteceu algo errado. Erro: ${error}`);
        } finally {
            this.loadingIntercorrencia = false;
        }
        },
         async getPaciente() {
            this.isLoadingPaciente = true;
            try {
                const { data } = await api.get(`/pacientes/app-pacientes/`);
                this.paciente = data.filter(item => item.ativo)
            } catch (error) {
                this.$toast.error(`Desculpe. Apresentou algum erro . ${error}`);
            } finally {
                this.isLoadingPaciente = false;
            }
        },
        validateAndSearch() {
            this.getIntercorrencia();
        },
        async save(fields) {
            try {
                // console.log(fields)
                await api.post(`/remocao/classificacao_acionamento_criar/`,fields );
                this.$toast.success("Acionamento Registrado com Sucesso!");
                this.dialog.create = false;
                this.dialog.create2 = false;
                this.atualizar()
                this.collapseAll();
            } catch (error) {
                console.error("❌ Erro ao salvar acionamento:", error);
                this.$toast.error(`Desculpe, aconteceu algum erro. ${error}`);
            } 
        },
        async atualizar() {
            const hoje = new Date();
            const primeiroDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);

            this.dataInicial = primeiroDiaMesAnterior.toISOString().split('T')[0];
            this.dataFinal = hoje.toISOString().split('T')[0];

            this.intercorrencia = [];
            this.expanded = [];
            this.filtroPaciente = null;
            this.filtroEquipeRemocao = null;
            this.filtroIntercorrencia = null;
            await this.getIntercorrencia();
            },
        pesquisar(){
            this.validateAndSearch()
        },
        closeDialog() {
        this.dialog.create = false;
        this.dialog.update= false;
        this.atualizar();
        },
        collapseAll() {
        this.expanded = [];
        },
        onSelectIntercorrencia(intercorrencia, action) {
            if (action === "update") {
                this.selectedIntercorrencia = intercorrencia;
                this.dialog.update = true;
            }
        },
    },
    computed: {
         headers() {
            const bp = this.$vuetify.breakpoint

            const baseHeaders = [
                { text: "Editar", value: "edit" },
                { text: "ID", sortable: true,value: "id",  },
                { text: "ID - Paciente", sortable: true,  width: 250,  value: "paciente.nome" },
                { text: "Tipo", sortable: true, value: "tipo.nome" },
                { text: "Data", sortable: true, value: "data" },
            ]
            const tabletHeaders = [
            // { text: "Data da Ocorrência", value: "dataOcorrencia", sortable: true },
            ]
            const desktopHeaders = [
            // { text: "Quem Registrou", value: "colaborador", sortable: true },
            // { text: "Responsável Pela Tratativa", value: "responsavel", sortable: true },
            ]
            if (bp.xs || bp.sm) {
            // Apenas baseHeaders em celulares
            return baseHeaders
            } else if (bp.md) {
            // Base + tablet
            return [...baseHeaders, ...tabletHeaders]
            } else {
            // Base + tablet + desktop
            return [...baseHeaders, ...tabletHeaders, ...desktopHeaders]
            }
        },
        quantidadeAcionamentos() {
            return this.intercorrencia.length;
        },
        quantidadeOcorrencia() {
            return this.intercorrencia.filter(item => item.intercorrencia === false).length;
        },
        quantidadeIntercorrencia() {
            return this.intercorrencia.filter(item => item.intercorrencia === true).length;
        },
        quantidadeAcionamentosRemocao() {
            return this.intercorrencia.filter(item => item.equipe_remocao === true).length;
        },
        quantidadeAcionamentosAssistencia() {
            return this.intercorrencia.filter(item => item.equipe_remocao === true).length;
        },
        quantidadeHospitalizacao() {
            return this.intercorrencia.filter(item => item.reinternacao === true).length;
        },
        quantidadeNaoHospitalizacao() {
            return this.intercorrencia.filter(item => item.reinternacao ===false).length;
        },
        quantidadeAcionamentosPorPaciente() {
            const contagem = {};

            this.intercorrencia.forEach(item => {
                const nome = item.paciente?.nome || 'Desconhecido';
                if (contagem[nome]) {
                contagem[nome]++;
                } else {
                contagem[nome] = 1;
                }
            });
            return contagem;
        },
        causasFiltradas() {
            const contagem = {};
            this.intercorrencia.forEach(item => {
            const nome = item.causa?.nome;
            if (nome) {
                contagem[nome] = (contagem[nome] || 0) + 1;
            }
            });
            return contagem;
        },
        tipoFiltradas() {
            const contagem = {};
            this.intercorrencia.forEach(item => {
            const nome = item.tipo?.nome;
            if (nome) {
                contagem[nome] = (contagem[nome] || 0) + 1;
            }
            });
            return contagem;
        },
        // quantidadeAcionamentosPorTipo() {
        //     const contagem = {};
        //     this.intercorrencia.forEach(item => {
        //     const nome = item.tipo?.nome || 'Sem tipo';
        //         contagem[nome] = (contagem[nome] || 0) + 1;
        //     });
        //     return contagem;
        // },
        quantidadeAcionamentosPorTipoProcedimento() {
            const contagem = {};
            this.intercorrencia.forEach(item => {
            const nome = item.tipo_ocorrencia?.nome || 'Sem tipo';
            contagem[nome] = (contagem[nome] || 0) + 1;
            });
            return contagem;
        }
    },
    mounted() {
        this.getIntercorrencia() 
        this.getPaciente()   
    },
}

</script>

<style>
.container {
  display: flex;
  width: 100%;
  gap: 0.2rem;
  flex-direction: column;
  background-color: white;
}
.title-container {
  display: flex;
  align-items: center;
  justify-content: center; /* Centraliza os elementos horizontalmente */
  flex-wrap: nowrap; /* Impede que os elementos sejam quebrados em linhas diferentes */
}
.red_color {
  font-weight: bold;
  color: red;
  background-color: white; /* Garante o fundo branco */
}
.orange_color {
  font-weight: bold;
  color: orange;
  background-color: white; /* Garante o fundo branco */
}

</style>